import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

// Single source of truth for whether the cookie notice has been accepted, shared
// reactively so other bottom toasts (e.g. the Chrome-theme match offer) can stack
// above the cookie bar while it is visible and drop down once it is dismissed.
const STORAGE_KEY = 'cookiesAccepted';

@Injectable( { providedIn: 'root' } )
export class CookieConsentService {

  private acceptedSubject: BehaviorSubject<boolean>;
  accepted: Observable<boolean>;

  constructor() {
    this.acceptedSubject = new BehaviorSubject<boolean>( this.read() );
    this.accepted = this.acceptedSubject.asObservable();
  }

  isAccepted(): boolean {
    return this.acceptedSubject.value;
  }

  accept(): void {
    try {
      localStorage.setItem( STORAGE_KEY, JSON.stringify( true ) );
    } catch ( e ) {
      // storage unavailable, keep the in-memory state at least for this session.
    }
    this.acceptedSubject.next( true );
  }

  private read(): boolean {
    try {
      return !!localStorage.getItem( STORAGE_KEY );
    } catch ( e ) {
      return false;
    }
  }
}
